<script setup lang="ts">
import { PhMapPin } from '@phosphor-icons/vue'

defineProps<{ name: string; routeCodes: string[]; selected?: boolean }>()

/** Tapping the row selects it and lets the parent decide what that means. */
defineEmits<{ select: [] }>()
</script>

<template>
  <div
    class="flex items-start gap-3 border-b px-3 py-2.5 transition-colors"
    :class="selected ? 'bg-muted' : ''"
  >
    <span
      class="flex size-8 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground"
    >
      <PhMapPin class="size-4" />
    </span>

    <button type="button" class="min-w-0 flex-1 text-left" @click="$emit('select')">
      <span class="block text-sm">{{ name }}</span>
      <!--
        The mockup also carries a `Road:` line. The dataset has no street field
        for a stop, so it is omitted rather than invented — see the parent PRD's
        known data gaps.

        Truncated to one line: a stop can be served by 26 routes, and wrapping
        that list would push every other row off the screen.
      -->
      <span class="mt-0.5 block truncate text-xs text-muted-foreground">
        Passing route: {{ routeCodes.join(', ') }}
      </span>
    </button>
  </div>
</template>
